<script lang="ts">
	export let progress = 0, message = ''
  let progressBar: HTMLDivElement;

	$: if (progressBar) progressBar.style.setProperty('width', `${progress}%`)
</script>

{#if message}
<div class="ml-2 mb-1">
	{message}
</div>
<div class="progress progress-striped active mx-0 mt-0 mb-3" role="progressbar">
	<div bind:this={progressBar} class="progress-bar progress-bar-success" style="width: 0%;"></div>
</div>
{/if}